import TermsConditions from "../components/Privacyandterms/TermsConditions"







const Termspage = () => {
  return (
    <div>
  
        <TermsConditions/>


    </div>
  )
}

export default Termspage